export const BACKEND_URL = "https://cartera360.collectiabpo.com";
export const BACKEND_PORT = "443";
export const BACKEND_API = `${BACKEND_URL}/cartera360`;
